import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            内容分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            按主题领域浏览 hitozuma 文化相关内容，选择您感兴趣的分类开始探索
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group cursor-pointer"
            >
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all h-full flex flex-col">
                <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${cat.icon} text-xl text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 whitespace-nowrap">
                    浏览分类
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}